<template>
  <div class="result-part">
    <div class="result-date">
      <p v-if="gmailModeration">
        Gmail аккаунт зарегистрирован: {{ getDate(data.date) }}
      </p>
      <template v-else>
        <p v-if="!data.isCreAso">
          Результат
        </p>
        <p>Загружен {{ getDate(data.date) }}</p>
      </template>
    </div>
    <div :class="['result-content', {'left-align': gmailModeration}]">
      <div v-if="gmailModeration" class="session-data">
        <div v-for="(value, key, index) in authGmail" :key="key + '-' +index" class="session-data-item">
          <span :class="['item-title', {'max-width': checkTitleField(key)}]">{{ key }}:</span>
          <span v-if="showEmptyField(value)">{{ value }}</span>
          <block-copy v-else :text="value"/>
        </div>
      </div>
      <template v-else>
        <div v-if="isImg" class="result-wrapper-image">
          <img :src="image.src" alt="скриншот">
          <el-tooltip
            effect="dark"
            content="Скачать скриншот">
            <a class="image-download-icon" :href="image.link" download>
              <el-icon>
                <Download/>
              </el-icon>
            </a>
          </el-tooltip>
        </div>
        <div class="result-wrapper-link" :class="{'show-wrapper': moderatedResult}">
          <a
            v-if="link"
            class="result-link"
            :href="link"
            target="_blank">Посмотреть результат по ссылке</a>
        </div>
        <files-uploader
          v-if="file[0]"
          :files="file"
          mode="list"
          can-download/>
      </template>
    </div>
  </div>
</template>

<script>
import FilesUploader from '@/components/UIComponents/Custom/FilesUploader'
import { addFirstSlash, getFileUrl, isModeratedTask } from '@/utils/helpers'
import { ElTooltip } from 'element-plus'
import moment from 'moment/moment'
import { mapGetters } from 'vuex'
import { SIDEBAR_ROUTES_NAMES } from "@/utils/constants"
import BlockCopy from "@/components/UIComponents/Custom/BlockCopy.vue"

export default {
  name: "SimpleModerationResultPart",
  components: {
    FilesUploader,
    ElTooltip,
    BlockCopy
  },
  props: {
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => ({
    smsNumbersFields: [
      {title: 'Телефон для регистрации',
        step: 1},
      {title: 'Телефон 2Auth',
        step: 2}
    ]
  }),
  computed: {
    ...mapGetters({
      moderation: 'selectedTask'
    }),
    isImg() {
      return !!this.moderation.related_user_simple?.meta.result.image
    },
    image() {
      return {
        src: getFileUrl(this.moderation.related_user_simple?.meta.result.image),
        link: '/cdn' + addFirstSlash(this.moderation.related_user_simple?.meta.result.image)
      }
    },
    link() {
      return this.moderation.related_user_simple?.meta.result.link
    },
    file() {
      const resultFile = !this.data.isCreAso ? this.moderation.related_user_simple?.meta.result.file : this.moderation.meta.result.file
      return [resultFile]
    },
    moderatedResult() {
      return isModeratedTask() && !this.img && !this.file[0]
    },
    actualPath() {
      return this.$route.name
    },
    gmailModeration() {
      return this.actualPath === SIDEBAR_ROUTES_NAMES.simpleTasks.simpleModerationGmailTasks
    },
    authGmail() {
      if (!this.gmailModeration) return
      const authData = {}
      const dataGmail = this.moderation.related_user_simple.google_account
      if (dataGmail.numbers.length > 1) {
        this.smsNumbersFields.forEach(field => {
          const phone = dataGmail.numbers.find(num => num.step === field.step)?.phone
          authData[field.title] = phone ?? 'данные отсутствуют'
        })
      } else {
        authData[this.smsNumbersFields[0].title] = 'данные отсутствуют'
        authData[this.smsNumbersFields[1].title] = dataGmail.numbers[0]?.phone ?? 'данные отсутствуют'
      }
      authData['Email'] = dataGmail.email
      authData['Пароль'] = dataGmail.password
      authData['Коды доступа'] = dataGmail.codes.join(', ')
      return authData
    }
  },
  methods: {
    getDate(date) {
      if (!date) return ''
      return moment(date)
        .format('DD.MM.YYYY')
    },
    checkTitleField(field) {
      const smsTitleFields = this.smsNumbersFields.map(smsNumber => smsNumber.title)
      return smsTitleFields.includes(field)
    },
    showEmptyField(value) {
      return value === 'данные отсутствуют'
    }
  }
}
</script>

<style scoped>

</style>
